function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.465 6.33341H30.0833C31.825 6.33341 33.25 7.75841 33.25 9.80808V31.6667C33.25 33.4084 31.825 34.8334 30.0833 34.8334H7.91667C6.175 34.8334 4.75 33.4084 4.75 31.6667V9.80808C4.75 7.75841 6.175 6.33341 7.91667 6.33341H14.535C15.2 4.49675 16.9417 3.16675 19 3.16675C21.0583 3.16675 22.8 4.49675 23.465 6.33341ZM20.5833 7.91675C20.5833 7.04591 19.8708 6.33341 19 6.33341C18.1292 6.33341 17.4167 7.04591 17.4167 7.91675C17.4167 8.78758 18.1292 9.80808 19 9.80808C19.8708 9.80808 20.5833 8.78758 20.5833 7.91675ZM19 12.6667C21.6283 12.6667 23.75 14.7884 23.75 17.4167C23.75 20.0451 21.6283 22.1667 19 22.1667C16.3717 22.1667 14.25 20.0451 14.25 17.4167C14.25 14.7884 16.3717 12.6667 19 12.6667ZM9.5 29.4501V31.6667H28.5V29.4501C28.5 26.2834 22.1667 24.5417 19 24.5417C15.8333 24.5417 9.5 26.2834 9.5 29.4501Z",
  fill: "#282828"
});

var SvgAdmin = function SvgAdmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/admin.6b50e3fb.svg";
export { ForwardRef as ReactComponent };